export var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
    SortDirection["None"] = "none";
})(SortDirection || (SortDirection = {}));
